import IconSpeed from "@components/Images/IconSpeed";
import { Box, Typography, useTheme } from "@mui/material";

const ExpedienteSegundoAvalCompletado = () => {
  const theme = useTheme();
  return (
    <Box py={8}>
      <Typography
        mt={4}
        mb={4}
        variant={"h4"}
        fontWeight={600}
        sx={{ color: theme?.palette?.primary?.dark }}
        textAlign={"center"}
      >
        ¡Concluiste exitosamente tu expediente!
      </Typography>
      <Box
        sx={{
          mt: 5,
          mb: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconSpeed fill={theme.palette.primary.dark} />
      </Box>
    </Box>
  );
};
export default ExpedienteSegundoAvalCompletado;
